import React, { useState, useContext, useEffect } from "react";
import {
    Grid,
    Box,
    TextField,
    MenuItem,
    Button,
    CardContent,
    Card,
    IconButton,
} from "@mui/material";
import imgPrueba from "../../logo.svg";
import CloseIcon from "@mui/icons-material/Close";
import { observer } from "mobx-react-lite";
import { ErrorMessages } from "../../app/util/messages";
import { validateEmail } from "../../app/util/util";
import InputMask from "react-input-mask";
import { RootStoreContext } from "../../app/store/root";
import DialogComponent from "../../app/common/DialogComponent";
import { EnumConfiguracion, EnumPerfiles } from '../../shared/Enumerables.js'
import { account } from '../../shared/Utils.js'
import { FileUpload } from "@mui/icons-material";
import { Acciones } from "../../app/util/permisos"
import { mode } from "crypto-js";
import { blobToBase64 } from "../../app/util/util";
import { toJS } from "mobx";

export const FormUsuario = ({ onClose, data, onFinish, idUsuario }) => {
    const rootStore = useContext(RootStoreContext);

    const { getAll: getPerfiles, entities: perfiles } = rootStore.perfilStore;

    const [verPerfil, setVerPerfil] = useState(false)
    const [verProveedor, setVerProveedor] = useState(false)

    const {
        create: crearUsuario,
        update: updateUsuario,
        validarDatosUsuario: _validarDatosUsuario,
        consultarArchivoUsuario: _consultarArchivoUsuario
    } = rootStore.usuarioStore;

    const { entities: proveedores, getAll: getAllProveedores } =
        rootStore.proveedorStore;

    const initialState = {
        Nombre: undefined,
        ApellidoPaterno: undefined,
        ApellidoMaterno: undefined,
        Correo: undefined,
        Correo2: undefined,
        Celular: undefined,
        IdPerfil: undefined,
        Contraseña: undefined,
        Contraseña2: undefined,
        ArchivoAdjunto: undefined,
        NombreArchivo: undefined,
        CambioArchivo: false
    }

    const [contraseniaLongitudMinima, setContraseniaLongitudMinima] = useState(null)
    const [contraseniaLongitudMaxima, setContraseniaLongitudMaxima] = React.useState(null);
    const [contraseniaRequiereMayusculas, setContraseniaRequiereMayusculas] = React.useState(null)
    const [contraseniaRequiereNumeros, setContraseniaRequiereNumeros] = React.useState(null)
    const [contraseniaRequiereCaracteresEspeciales, setContraseniaRequiereCaracteresEspeciales] = React.useState(null)

    const [disabled, setDisabled] = useState(false);
    const [title, setTitle] = useState(undefined);
    const [model, setModel] = useState(initialState);
    const [showDialogClear, setShowDialogClear] = useState(false);
    //const [id, setId] = useState(undefined);

    const [errors, setErrors] = useState({
        Nombre: null,
        ApellidoPaterno: null,
        ApellidoMaterno: null,
        Correo: null,
        Correo2: null,
        Celular: null,
        IdPerfil: null,
        Contraseña: null,
        Contraseña2: null,
    });
    const [messages, setMessages] = useState({
        Nombre: "",
        ApellidoPaterno: "",
        ApellidoMaterno: "",
        Correo: "",
        Correo2: "",
        Celular: "",
        IdPerfil: "",
        Contraseña: "",
        Contraseña2: "",
    });

    const [esEditar, setEsEditar] = useState(false);
    const [idPerfil, setIdPerfil] = useState(null);
    const [permisosUsuario, setPermisosUsuario] = useState([])
    const [urlBlob, setUrlBlob] = useState(null);

    useEffect(() => {
        setPermisosUsuario(account.getPermisosUsuario())
        loadPage()
    }, [])

    const loadPage = async () => {
        await getPerfiles()
        getAllProveedores();
        setTitle(data != null ? "Edición Usuario" : "Registro Usuario")
        cargarConfiguracionContrasenia()
        if (!data) {
            setEsEditar(false)
            setVerPerfil(true)
            setVerProveedor(false)
        } else {
            setEsEditar(true)
            setModel({ ...data, Correo2: data.Correo });
            setErrors({
                Nombre: false,
                ApellidoPaterno: false,
                ApellidoMaterno: false,
                Correo: false,
                Correo2: false,
                Celular: false,
                IdPerfil: false,
                Contraseña: false,
                Contraseña2: false,
            });
            consultarArchivoUsuario(idUsuario)
            setIdPerfil(data.IdPerfil)
            if (perfiles.find(a => a.idPerfil == data.IdPerfil)?.esInterno == true) {
                setVerPerfil(true)
                setVerProveedor(false)
            } else {
                setVerPerfil(false)
                setVerProveedor(true)
            }
        }
    }

    useEffect(() => {
        if (errors.Nombre == false && errors.ApellidoPaterno == false && errors.ApellidoMaterno == false && errors.Correo == false && errors.Correo2 == false
            && errors.Celular == false && errors.IdPerfil == false && errors.Contraseña == false && errors.Contraseña2 == false)
            setDisabled(false);
        else
            setDisabled(true);

    }, [errors])

    useEffect(() => {
        if (contraseniaLongitudMinima && contraseniaLongitudMaxima) {
            ErrorMessages.usuario.ContraseñaLongitud = ErrorMessages.usuario.ContraseñaLongitud.replace('{0}', contraseniaLongitudMinima.valor)
            ErrorMessages.usuario.ContraseñaLongitud = ErrorMessages.usuario.ContraseñaLongitud.replace('{1}', contraseniaLongitudMaxima.valor)
        }
    }, [contraseniaLongitudMinima, contraseniaLongitudMaxima])

    useEffect(() => {
        setIdPerfil(model.IdPerfil);
    }, [model.IdPerfil])

    const consultarArchivoUsuario = async (idUsuario) => {
        let pdf = await _consultarArchivoUsuario(idUsuario)
        if (pdf != null) {
            const pdfBase64 = await blobToBase64(pdf.data)
            setUrlBlob(pdfBase64);
        }
    }

    const cargarConfiguracionContrasenia = async () => {
        setContraseniaLongitudMinima(await consultarParametro(EnumConfiguracion.Contrasenia_Longitud_Minima))
        setContraseniaLongitudMaxima(await consultarParametro(EnumConfiguracion.Contrasenia_Longitud_Maxima))
        setContraseniaRequiereMayusculas(await consultarParametro(EnumConfiguracion.Contrasenia_Requiere_Mayusculas))
        setContraseniaRequiereNumeros(await consultarParametro(EnumConfiguracion.Contrasenia_Requiere_Numeros))
        setContraseniaRequiereCaracteresEspeciales(await consultarParametro(EnumConfiguracion.Contrasenia_Requiere_Caracteres_Especiales))
    }

    const consultarParametro = (claveParametro) => {
        return new Promise((resolve) => {
            try {
                fetch(
                    `${process.env.REACT_APP_API_LOGISTICA}/api/Configuracion/ConsultarParametro/${claveParametro}`,
                    {
                        method: "GET",
                        mode: "cors",
                        cache: "no-cache",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${account.getToken()}`,
                        },
                    }
                )
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.success) {
                            resolve(response.data);
                        } else resolve(null);
                    });
            } catch {
                resolve(null);
            }
        });
    };

    /* Methods */
    const setValue = (key, value) => {
        setModel({ ...model, ...{ [key]: value } });
    };
    const setError = (key, value) => {
        setErrors({ ...errors, ...{ [key]: value } });
    };
    const setMessage = (key, value) => {
        setMessages({ ...messages, ...{ [key]: value } });
    };

    const validationEmail = (Campo, e) => {
        setValue(Campo, e.target.value);
        if (e.target.value.length > 0) {
            if (validateEmail(e.target.value)) {
                setError(Campo, false);
                setMessage(Campo, "");
            } else {
                setError(Campo, true);
                setMessage(Campo, ErrorMessages.proveedor.EmailFormatIncorrect)
                return
            }
            if ((Campo == 'Correo' && model.Correo2?.length > 0) && e.target.value?.toUpperCase() !== model.Correo2?.toUpperCase()) {
                setError(Campo, true)
                setMessage(Campo, ErrorMessages.usuario.CorreosDiferentes)
            }
            if ((Campo == 'Correo2' && model.Correo?.length > 0) && e.target.value?.toUpperCase() !== model.Correo?.toUpperCase()) {
                setError(Campo, true)
                setMessage(Campo, ErrorMessages.usuario.CorreosDiferentes)
            }

            if ((Campo == 'Correo' && model.Correo2?.length > 0 && e.target.value?.toUpperCase() === model.Correo2?.toUpperCase())
                || (Campo == 'Correo2' && model.Correo?.length > 0 && e.target.value?.toUpperCase() === model.Correo?.toUpperCase())) {
                setErrors({
                    ...errors,
                    ...{
                        Correo: false,
                        Correo2: false
                    },
                });
                setMessages({
                    ...messages,
                    ...{
                        Correo: '',
                        Correo2: '',
                    },
                });
                return
            }
        } else {
            setError(Campo, true);
            setMessage(Campo, ErrorMessages.proveedor.EmailRequired);
            rootStore.alertStore.alertError("Ingrese la información requerida");
        }
    };

    const clearInitialState = () => {
        initialErrors();
        setModel({ ...initialState });
        setModel({
            Nombre: undefined,
            ApellidoPaterno: undefined,
            ApellidoMaterno: undefined,
            Correo: undefined,
            Correo2: undefined,
            Celular: undefined,
            IdPerfil: (permisosUsuario.some(a => a.clavePermiso == Acciones.Editar_perfil_usuario && a.tienePermiso) || !esEditar) ? undefined : model.IdPerfil,
            IdProveedor: model.IdProveedor,
            Contraseña: undefined,
            Contraseña2: undefined,
            ArchivoAdjunto: model.ArchivoAdjunto,
            NombreArchivo: model.NombreArchivo,
            CambioArchivo: model.CambioArchivo
        })
    };

    const initialErrors = () => {
        setErrors({
            ...errors,
            ...{
                Nombre: true,
                ApellidoPaterno: true,
                ApellidoMaterno: true,
                Correo: true,
                Correo2: true,
                Celular: true,
                IdPerfil: (permisosUsuario.some(a => a.clavePermiso == Acciones.Editar_perfil_usuario && a.tienePermiso) || !esEditar) ? true : false,
                Contraseña: true,
                Contraseña2: true
            },
        });
        setMessages({
            ...messages,
            ...{
                Nombre: ErrorMessages.usuario.Nombre,
                ApellidoPaterno: ErrorMessages.usuario.ApellidoPaterno,
                ApellidoMaterno: ErrorMessages.usuario.ApellidoMaterno,
                Correo: ErrorMessages.usuario.Correo,
                Correo2: ErrorMessages.usuario.Correo,
                Celular: ErrorMessages.usuario.Celular,
                IdPerfil: (permisosUsuario.some(a => a.clavePermiso == Acciones.Editar_perfil_usuario && a.tienePermiso) || !esEditar) ? '' : ErrorMessages.usuario.IdPerfil,
                Contraseña: ErrorMessages.usuario.ContraseñaLongitud,
                Contraseña2: ErrorMessages.usuario.ContraseñaLongitud,
            },
        });
    };

    const validarDatosUsuario = async () => {
        if (validarUsuario()) {
            rootStore.logisticBackdropStore.openLoading()
            let resp = await _validarDatosUsuario(idUsuario ?? null, model)
            if (resp != null) {
                if (resp.validations?.length == 0) {
                    setShowConfirmGuardar(true)
                } else {
                    const Errors = {
                        Nombre: errors.Nombre,
                        ApellidoPaterno: errors.ApellidoPaterno,
                        ApellidoMaterno: errors.ApellidoMaterno,
                        Correo: errors.Correo,
                        Correo2: errors.Correo2,
                        Celular: errors.Celular,
                        IdPerfil: errors.IdPerfil,
                        Contraseña: errors.Contraseña,
                        Contraseña2: errors.Contraseña2,
                    }
                    const Mensajes = {
                        Nombre: messages.Nombre,
                        ApellidoPaterno: messages.ApellidoPaterno,
                        ApellidoMaterno: messages.ApellidoMaterno,
                        Correo: messages.Correo,
                        Correo2: messages.Correo2,
                        Celular: messages.Celular,
                        IdPerfil: messages.IdPerfil,
                        Contraseña: messages.Contraseña,
                        Contraseña2: messages.Contraseña2
                    }
                    resp.validations.forEach(element => {
                        if (element.campo.toUpperCase() == 'Correo'.toUpperCase()) {
                            Errors.Correo = true
                            Mensajes.Correo = element.mensaje
                        }
                        if (element.campo.toUpperCase() == 'Celular'.toUpperCase()) {
                            Errors.Celular = true
                            Mensajes.Celular = element.mensaje
                        }
                    });
                    setErrors({ ...Errors })
                    setMessages({ ...Mensajes })
                }
            }
            rootStore.logisticBackdropStore.closeLoading()
        }
    }

    const guardarUsuario = async () => {
        if (validarUsuario()) {
            rootStore.logisticBackdropStore.openLoading()
            if (idUsuario == null || idUsuario == undefined) {
                await crearUsuario(model).then((resp) => {
                    if (resp.success) {
                        if (resp.data?.validations?.length == 0) {
                            onFinish(true)
                        }
                        if (resp.data.validations.length > 0) {
                            const Errors = {
                                Nombre: errors.Nombre,
                                ApellidoPaterno: errors.ApellidoPaterno,
                                ApellidoMaterno: errors.ApellidoMaterno,
                                Correo: errors.Correo,
                                Correo2: errors.Correo2,
                                Celular: errors.Celular,
                                IdPerfil: errors.IdPerfil,
                                Contraseña: errors.Contraseña,
                                Contraseña2: errors.Contraseña2,
                            }
                            const Mensajes = {
                                Nombre: messages.Nombre,
                                ApellidoPaterno: messages.ApellidoPaterno,
                                ApellidoMaterno: messages.ApellidoMaterno,
                                Correo: messages.Correo,
                                Correo2: messages.Correo2,
                                Celular: messages.Celular,
                                IdPerfil: messages.IdPerfil,
                                Contraseña: messages.Contraseña,
                                Contraseña2: messages.Contraseña2
                            }
                            resp.data.validations.forEach(element => {
                                if (element.campo.toUpperCase() == 'Correo'.toUpperCase()) {
                                    Errors.Correo = true
                                    Mensajes.Correo = element.mensaje
                                }
                                if (element.campo.toUpperCase() == 'Celular'.toUpperCase()) {
                                    Errors.Celular = true
                                    Mensajes.Celular = element.mensaje
                                }
                            });
                            setErrors({ ...Errors })
                            setMessages({ ...Mensajes })
                        }
                    } else {

                    }
                }, (err) => { });
            }
            else {
                await updateUsuario(idUsuario, model).then((resp) => {
                    if (resp.success)
                        onFinish(true)
                    else {
                        if (resp.data.validations.length > 0) {
                            const Errors = {
                                Nombre: errors.Nombre,
                                ApellidoPaterno: errors.ApellidoPaterno,
                                ApellidoMaterno: errors.ApellidoMaterno,
                                Correo: errors.Correo,
                                Correo2: errors.Correo2,
                                Celular: errors.Celular,
                                IdPerfil: errors.IdPerfil,
                                Contraseña: errors.Contraseña,
                                Contraseña2: errors.Contraseña2,
                            }
                            const Mensajes = {
                                Nombre: messages.Nombre,
                                ApellidoPaterno: messages.ApellidoPaterno,
                                ApellidoMaterno: messages.ApellidoMaterno,
                                Correo: messages.Correo,
                                Correo2: messages.Correo2,
                                Celular: messages.Celular,
                                IdPerfil: messages.IdPerfil,
                                Contraseña: messages.Contraseña,
                                Contraseña2: messages.Contraseña2
                            }
                            resp.data.validations.forEach(element => {
                                if (element.campo.toUpperCase() == 'Correo'.toUpperCase()) {
                                    Errors.Correo = true
                                    Mensajes.Correo = element.mensaje
                                }
                                if (element.campo.toUpperCase() == 'Celular'.toUpperCase()) {
                                    Errors.Celular = true
                                    Mensajes.Celular = element.mensaje
                                }
                            });
                            setErrors({ ...Errors })
                            setMessages({ ...Mensajes })
                        }
                    }
                }, (err) => { });
            }
            rootStore.logisticBackdropStore.closeLoading()
        }
    }

    const validarUsuario = () => {
        const Errors = {
            Nombre: false,
            ApellidoPaterno: false,
            ApellidoMaterno: false,
            Correo: false,
            Correo2: false,
            Celular: false,
            IdPerfil: false,
            Contraseña: false,
            Contraseña2: false,
        }
        const Mensajes = {
            Nombre: '',
            ApellidoPaterno: '',
            ApellidoMaterno: '',
            Correo: '',
            Correo2: '',
            Celular: '',
            IdPerfil: '',
            Contraseña: '',
            Contraseña2: '',
        }
        if (!model.Nombre || model.Nombre?.length == 0) {
            Errors.Nombre = true
            Mensajes.Nombre = ErrorMessages.usuario.Nombre
        }
        if (!model.ApellidoPaterno || model.ApellidoPaterno?.length == 0) {
            Errors.ApellidoPaterno = true
            Mensajes.ApellidoPaterno = ErrorMessages.usuario.ApellidoPaterno
        }
        if (!model.ApellidoMaterno || model.ApellidoMaterno?.length == 0) {
            Errors.ApellidoMaterno = true
            Mensajes.ApellidoMaterno = ErrorMessages.usuario.ApellidoMaterno
        }
        if (!model.Correo || model.Correo?.length == 0) {
            Errors.Correo = true
            Mensajes.Correo = ErrorMessages.usuario.Correo
        }
        if (!model.Correo2 || model.Correo2?.length == 0) {
            Errors.Correo2 = true;
            Mensajes.Correo2 = ErrorMessages.usuario.Correo;
        }
        if (!model.Celular || model.Celular?.length != 10) {
            Errors.Celular = true
            Mensajes.Celular = ErrorMessages.usuario.Celular
        }
        if (model.IdPerfil == undefined || model.IdPerfil == null) {
            Errors.IdPerfil = true
            Mensajes.IdPerfil = ErrorMessages.usuario.IdPerfil
        }
        if (model.Correo != model.Correo2) {
            Errors.Correo2 = true;
            Mensajes.Correo2 = ErrorMessages.usuario.CorreosDiferentes;
        }
        //Validar contraseña vs configuracion
        if ((model.Contraseña?.length ?? 0) < parseInt(contraseniaLongitudMinima.valor) || (model.Contraseña?.length ?? 0) > parseInt(contraseniaLongitudMaxima.valor)) {
            Errors.Contraseña = true
            Mensajes.Contraseña = ErrorMessages.usuario.ContraseñaLongitud
        }
        if ((model.Contraseña2?.length ?? 0) < parseInt(contraseniaLongitudMinima.valor) || (model.Contraseña2?.length ?? 0) > parseInt(contraseniaLongitudMaxima.valor)) {
            Errors.Contraseña2 = true
            Mensajes.Contraseña2 = ErrorMessages.usuario.ContraseñaLongitud
        }
        if (contraseniaRequiereMayusculas?.valor == 'True' && model.Contraseña.search(/[A-Z]/i) < 0) {
            Errors.Contraseña = true
            Mensajes.Contraseña = ErrorMessages.usuario.ContraseñaMayuscula
        }
        if (contraseniaRequiereNumeros?.valor == 'True' && model.Contraseña.search(/[0-9]/) < 0) {
            Errors.Contraseña = true
            Mensajes.Contraseña = ErrorMessages.usuario.ContraseñaNumero
        }
        if (contraseniaRequiereCaracteresEspeciales?.valor == 'True' && model.Contraseña.search(/(?=.*[ñÑ\-_¿.#¡!@$%^&*])/) < 0) {
            Errors.Contraseña = true
            Mensajes.Contraseña = ErrorMessages.usuario.ContraseñaCaracter
        }
        if (model.Contraseña != model.Contraseña2) {
            Errors.Contraseña = true
            Mensajes.Contraseña = ErrorMessages.usuario.ContraseñasDiferentes
            Errors.Contraseña2 = true
            Mensajes.Contraseña2 = ErrorMessages.usuario.ContraseñasDiferentes
        }

        setErrors({ ...Errors });
        setMessages({ ...Mensajes });
        if (
            Errors.Nombre ||
            Errors.ApellidoPaterno ||
            Errors.ApellidoMaterno ||
            Errors.Correo ||
            Errors.Correo2 ||
            Errors.Celular ||
            Errors.IdPerfil ||
            Errors.Contraseña ||
            Errors.Contraseña2
        )
            return false;
        return true;
    };

    const eliminarArchivo = (event) => {
        event.preventDefault()
        setModel({
            Nombre: model.Nombre,
            ApellidoPaterno: model.ApellidoPaterno,
            ApellidoMaterno: model.ApellidoMaterno,
            Correo: model.Correo,
            Correo2: model.Correo2,
            Celular: model.Celular,
            IdPerfil: model.IdPerfil,
            Contraseña: model.Contraseña,
            Contraseña2: model.Contraseña2,
            ArchivoAdjunto: null,
            NombreArchivo: null,
            CambioArchivo: true
        });
        setUrlBlob(null)
        document.getElementById('file').value = []
    }

    const changeHandler = async (event) => {
        if (event?.target?.files?.length > 0) {
            var fileZise = event.target.files[0].size
            fileZise = parseInt(fileZise / 1024) + 1
            if (fileZise > 3000) {
                rootStore.alertStore.alertError('La imagen debe de pesar máximo 3 MB')
                document.getElementById('file').value = []
                return
            }
            var base64File = await getBase64(event.target.files[0])
            if (base64File != null) {
                setModel({
                    Nombre: model.Nombre,
                    ApellidoPaterno: model.ApellidoPaterno,
                    ApellidoMaterno: model.ApellidoMaterno,
                    Correo: model.Correo,
                    Correo2: model.Correo2,
                    Celular: model.Celular,
                    IdPerfil: model.IdPerfil,
                    Contraseña: model.Contraseña,
                    Contraseña2: model.Contraseña2,
                    ArchivoAdjunto: base64File.split(',')[1],
                    NombreArchivo: event.target.files[0].name,
                    CambioArchivo: true
                });
                setUrlBlob(base64File);
            }
        }
    }

    const getBase64 = (file) => {
        return new Promise((resolve) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function (error) {
                resolve(null);
            };
        });
    };

    const seleccionarArchivo = (e) => {
        e.preventDefault();
        let inputFile = document.getElementById("file");
        inputFile.click();
    };

    const validationContraseña = (campo, value) => {
        setValue(campo, value)        
        if (value.length < parseInt(contraseniaLongitudMinima?.valor ?? 6) || value.length > parseInt(contraseniaLongitudMaxima?.valor ?? 12)) {
            setError(campo, true)
            setMessage(campo, ErrorMessages.usuario.ContraseñaLongitud)
            return
        }

        if ((campo == 'Contraseña' && model.Contraseña2?.length > 0) && value?.toUpperCase() !== model.Contraseña2?.toUpperCase()) {
            setError(campo, true)
            setMessage(campo, ErrorMessages.usuario.ContraseñasDiferentes)
            return
        }
        if ((campo == 'Contraseña2' && model.Contraseña?.length > 0) && value?.toUpperCase() !== model.Contraseña?.toUpperCase()) {
            setError(campo, true)
            setMessage(campo, ErrorMessages.usuario.ContraseñasDiferentes)
            return
        }
        if ((campo == 'Contraseña' && model.Contraseña2?.length > 0 && value?.toUpperCase() === model.Contraseña2?.toUpperCase())
            || (campo == 'Contraseña2' && model.Contraseña?.length > 0 && value?.toUpperCase() === model.Contraseña?.toUpperCase())) {
            setErrors({
                ...errors,
                ...{
                    Contraseña: false,
                    Contraseña2: false
                },
            });
            setMessages({
                ...messages,
                ...{
                    Contraseña: '',
                    Contraseña2: '',
                },
            });
            return
        }
        setError(campo, false)
        setMessage(campo, '')
    }
    const passwordValidation = () => {
        if (model.Contraseña?.length > 0 && model.Contraseña2?.length > 0) {
            const Errors = {
                Nombre: errors.Nombre,
                ApellidoPaterno: errors.ApellidoPaterno,
                ApellidoMaterno: errors.ApellidoMaterno,
                Correo: errors.Correo,
                Correo2: errors.Correo2,
                Celular: errors.Celular,
                IdPerfil: errors.IdPerfil,
                Contraseña: false,
                Contraseña2: false,
            };
            const Mensajes = {
                Nombre: messages.Nombre,
                ApellidoPaterno: messages.ApellidoPaterno,
                ApellidoMaterno: messages.ApellidoMaterno,
                Correo: messages.Correo,
                Correo2: messages.Correo2,
                Celular: messages.Celular,
                IdPerfil: messages.IdPerfil,
                Contraseña: "",
                Contraseña2: "",
            };
            if (model.Contraseña != model.Contraseña2) {
                Errors.Contraseña = true;
                Mensajes.Contraseña = ErrorMessages.usuario.ContraseñasDiferentes;
                Errors.Contraseña2 = true;
                Mensajes.Contraseña2 = ErrorMessages.usuario.ContraseñasDiferentes;
            }
            setErrors({ ...Errors });
            setMessages({ ...Mensajes });
        }
    };

    const [showConfirmCerrar, setShowConfirmCerrar] = React.useState(false)
    const [showConfirmGuardar, setShowConfirmGuardar] = React.useState(false)
    return (
        <div>
            <Grid container spacing={3} mb={2}>
                <Grid item xs>
                    <h2 style={{ fontSize: 14 }}>
                        <strong>{title}</strong>
                    </h2>
                </Grid>
                <Grid item xs={6} />
                <Grid item xs>
                    <div style={{ position: "relative" }}>
                        <IconButton
                            aria-label="close"
                            onClick={(e) => setShowConfirmCerrar(true)}
                            style={{
                                position: "absolute",
                                top: "-10px",
                                right: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                </Grid>
            </Grid>
            <Box
                noValidate
                component="form"
                sx={{
                    display: "flex",
                    m: "auto",
                    width: "fit-content",
                }}
            >
                <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    <Grid item sm="6" md={verPerfil ? "8" : "12"}>
                        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs="6">
                                <TextField
                                    size="small"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="name"
                                    label="Nombre"
                                    name="name"
                                    inputProps={{ maxLength: 20 }}
                                    error={errors.Nombre}
                                    onChange={(e) => {
                                        setValue("Nombre", e.target.value);
                                        setError("Nombre", e.target.value.length <= 0);
                                        setMessage(
                                            "Nombre",
                                            e.target.value.length <= 0
                                                ? ErrorMessages.usuario.Nombre
                                                : ""
                                        );
                                        if (e.target.value.length <= 0) { rootStore.alertStore.alertError('Ingrese la información requerida') }
                                    }}
                                    helperText={messages.Nombre}
                                    value={model.Nombre || ""}
                                />
                            </Grid>
                            <Grid item xs="6">
                                <TextField
                                    size="small"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="apellidoPaterno"
                                    label="Apellido parterno"
                                    name="apellidoPaterno"
                                    inputProps={{ maxLength: 20 }}
                                    error={errors.ApellidoPaterno}
                                    onChange={(e) => {
                                        setValue("ApellidoPaterno", e.target.value);
                                        setError("ApellidoPaterno", e.target.value.length <= 0);
                                        setMessage(
                                            "ApellidoPaterno",
                                            e.target.value.length <= 0
                                                ? ErrorMessages.usuario.ApellidoPaterno
                                                : ""
                                        );
                                        if (e.target.value.length <= 0) { rootStore.alertStore.alertError('Ingrese la información requerida') }
                                    }}
                                    helperText={messages.ApellidoPaterno}
                                    value={model.ApellidoPaterno || ""}
                                />
                            </Grid>
                            <Grid item xs="6">
                                <TextField
                                    size="small"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="apellidoMaterno"
                                    label="Apellido materno"
                                    name="apellidoMaterno"
                                    inputProps={{ maxLength: 20 }}
                                    error={errors.ApellidoMaterno}
                                    onChange={(e) => {
                                        setValue("ApellidoMaterno", e.target.value);
                                        setError("ApellidoMaterno", e.target.value.length <= 0);
                                        setMessage(
                                            "ApellidoMaterno",
                                            e.target.value.length <= 0
                                                ? ErrorMessages.usuario.ApellidoMaterno
                                                : ""
                                        );
                                        if (e.target.value.length <= 0) { rootStore.alertStore.alertError('Ingrese la información requerida') }
                                    }}
                                    helperText={messages.ApellidoMaterno}
                                    value={model.ApellidoMaterno || ""}
                                />
                            </Grid>
                            <Grid item sm="6">
                                <TextField
                                    size="small"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="email"
                                    label="Correo electrónico"
                                    name="email"
                                    type="email"
                                    error={errors.Correo}
                                    autoComplete="off"
                                    onChange={(e) => validationEmail("Correo", e)}

                                    helperText={messages.Correo}
                                    value={model.Correo || ""}
                                >
                                </TextField>
                            </Grid>
                            <Grid item sm="6">
                                <TextField
                                    size="small"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="confirmEmail"
                                    label="Confirma Correo"
                                    name="confirmEmail"
                                    type="email"
                                    autoComplete="off"
                                    error={errors.Correo2}
                                    onChange={(e) => validationEmail("Correo2", e)}
                                    helperText={messages.Correo2}
                                    value={model.Correo2 || ""}
                                    onPaste={(e) => {
                                        e.preventDefault();
                                        return false;
                                    }}
                                    onCopy={(e) => {
                                        e.preventDefault();
                                        return false;
                                    }}
                                >
                                </TextField>
                            </Grid>
                            <Grid item sm="6">
                                <InputMask mask="999 999 99 99" maskChar=" "
                                    onChange={(e) => {
                                        setValue("Celular", e.target.value.replace(/\s+/g, ''));
                                        setError("Celular", e.target.value.replace(/\s+/g, '').length < 10);
                                        setMessage(
                                            "Celular",
                                            e.target.value.replace(/\s+/g, '').length < 10
                                                ? ErrorMessages.usuario.Celular
                                                : ""
                                        );
                                        if (e.target.value.length <= 0) { rootStore.alertStore.alertError('Ingrese la información requerida') }

                                    }}
                                    value={model.Celular || ""}
                                >
                                    {() => <TextField
                                        size="small"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="phone"
                                        label="Teléfono"
                                        name="phone"
                                        error={errors.Celular}
                                        helperText={messages.Celular}

                                    />}
                                </InputMask>
                            </Grid>
                            {verPerfil &&
                                <Grid item sm="6">
                                    <TextField
                                        size="small"
                                        margin="normal"
                                        select
                                        required
                                        fullWidth
                                        id="selectRol"
                                        label="Perfil"
                                        name="selectRol"
                                        error={errors.IdPerfil}
                                        InputLabelProps={{ shrink: idPerfil ? true : false }}
                                        disabled={!permisosUsuario.some(a => a.clavePermiso == Acciones.Editar_perfil_usuario && a.tienePermiso) && esEditar}
                                        onChange={(e) => {
                                            setValue('IdPerfil', e.target.value)
                                            setError("IdPerfil", (e.target.value == null || e.target.value == undefined));
                                            setMessage(
                                                "IdPerfil",
                                                (e.target.value == null && e.target.value == undefined)
                                                    ? ErrorMessages.usuario.ContraseñaLongitud
                                                    : ""
                                            );
                                            if (!e.target.value) { rootStore.alertStore.alertError('Ingrese la información requerida') }
                                        }}
                                        helperText={messages.IdPerfil}
                                        value={idPerfil}
                                    >
                                        {perfiles.filter(a => a.nombrePerfil?.toUpperCase() != EnumPerfiles.Proveedor).map((perfil) => (
                                            <MenuItem id={perfil.idPerfil} value={perfil.idPerfil}>{perfil.nombrePerfil}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            }
                            <Grid item sm="6">
                                <TextField
                                    size="small"
                                    type="password"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="password"
                                    label="Contraseña"
                                    name="password"
                                    inputProps={{ maxLength: parseInt(contraseniaLongitudMaxima?.valor ?? 12) }}
                                    error={errors.Contraseña}
                                    onChange={(e) => { validationContraseña("Contraseña", e.target.value) }}
                                    helperText={messages.Contraseña}
                                    value={model.Contraseña || ""}
                                    onPaste={(e) => {
                                        e.preventDefault()
                                        return false;
                                    }}
                                    onCopy={(e) => {
                                        e.preventDefault()
                                        return false;
                                    }}
                                    
                                />
                            </Grid>
                            <Grid item sm="6">
                                <TextField
                                    size="small"
                                    type="password"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="confirmPass"
                                    label="Confirma contraseña"
                                    name="confirmPass"
                                    inputProps={{ maxLength: parseInt(contraseniaLongitudMaxima?.valor ?? 12) }}
                                    error={errors.Contraseña2}
                                    onChange={(e) => { validationContraseña("Contraseña2", e.target.value) }}
                                    helperText={messages.Contraseña2}
                                    value={model.Contraseña2 || ""}
                                    onPaste={(e) => {
                                        e.preventDefault()
                                        return false;
                                    }}
                                    onCopy={(e) => {
                                        e.preventDefault()
                                        return false;
                                    }}
                                    
                                />
                            </Grid>
                            {verProveedor &&
                                <Grid item sm="6">
                                    <TextField
                                        size="small"
                                        margin="normal"
                                        select
                                        disabled
                                        required
                                        fullWidth
                                        id="selectProveedor"
                                        label="Proveedor"
                                        name="selectProveedor"
                                        value={model?.IdProveedor || ""}
                                    >
                                        {proveedores.map((proveedor, index) => (
                                            <MenuItem key={index} value={proveedor.id}>
                                                {proveedor.proveedores}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                    {verPerfil &&
                        <Grid item sm="6" md="4">
                            <Card className="card">
                                <CardContent sx={{ textAlign: 'center' }}>
                                    <Box component={"img"} src={urlBlob != null ? urlBlob : imgPrueba} alt="usuario" minWidth={"372px"} minHeight={"263px"} maxWidth={"372px"} maxHeight={"263px"} />
                                    {urlBlob == null &&
                                        <Button variant="contained" onClick={(e) => seleccionarArchivo(e)}>Cargar Imagen</Button>
                                    }
                                    {urlBlob != null &&
                                        <Button variant="contained" onClick={(e) => eliminarArchivo(e)}>Eliminar imagen</Button>
                                    }
                                    <input id="file" hidden={true} type="file" name="file" accept="image/jpg, image/png, image/bpm" onChange={(event) => { changeHandler(event) }} />
                                </CardContent>
                            </Card>
                        </Grid>
                    }
                </Grid>
            </Box>
            <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                mt={2}>
                <Button
                    onClick={() => setShowDialogClear(true)}
                    variant="contained"
                    color="secondary"
                    sx={{ color: "#fff" }}>
                    Limpiar
                </Button>
                <Button
                    type="submit"
                    onClick={() => { validarDatosUsuario() }}
                    variant="contained"
                    disabled={disabled}
                    style={{ marginLeft: 10 }}>
                    Aceptar
                </Button>
            </Grid>
            <DialogComponent
                Open={showDialogClear}
                Message="Se eliminará toda la información capturada. ¿Está seguro que desea continuar?"
                OnClose={() => setShowDialogClear(false)}
                OnAccept={() => {
                    clearInitialState();
                    setShowDialogClear(false);
                }}
            />
            <DialogComponent
                Open={showConfirmCerrar}
                Message="Si cierra esta ventana se perderá la información capturada. ¿Está seguro que desea continuar?"
                OnClose={() => setShowConfirmCerrar(false)}
                OnAccept={() => {
                    setShowConfirmCerrar(false)
                    onClose()
                }}
            />
            <DialogComponent
                Open={showConfirmGuardar}
                Message="¿Seguro que quiere guardar estos cambios?"
                OnClose={() => setShowConfirmGuardar(false)}
                OnAccept={() => {
                    guardarUsuario()
                    setShowConfirmGuardar(false)
                }}
            />
            {/*<DialogActions>
                <Button onClick={onClose} variant="contained" color="secondary" sx={{ color: '#fff' }}>Limpiar</Button>
                <Button onClick={onClose} variant="contained">Aceptar</Button>
            </DialogActions> */}
        </div>
    );
};

export default observer(FormUsuario);
